module.exports = __webpack_public_path__ + "img/shape-57.23f13a87.svg";